(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["contact-form"] && !Shopify.designMode) return;
  try {
    document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.contact-form__form').forEach(function (form) {
      form.addEventListener('submit', function (e) {
        var hp = form.querySelector('#ContactForm-hp');
        if (hp && hp.value.length > 0) {
          e.preventDefault();
          // Show fake success so the bot thinks it worked
          var success = form.querySelector('.contact-form__success');
          if (!success) {
            success = document.createElement('div');
            success.className = 'contact-form__success';
            success.textContent = 'Thanks for your message!';
            form.prepend(success);
          }
          form.reset();
        }
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
